import { render, staticRenderFns } from "./EventRequest.vue?vue&type=template&id=6f0a3636&lang=pug"
import script from "./EventRequest.vue?vue&type=script&lang=js"
export * from "./EventRequest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports